"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = require("react");
const components_1 = require("components");
const propTypes = {
    data: prop_types_1.default.object.isRequired,
    setData: prop_types_1.default.func.isRequired,
    selectAllLocation: prop_types_1.default.func.isRequired,
    allSelected: prop_types_1.default.bool.isRequired,
};
const ApplicationActionCell = ({ data, setData, selectAllLocation, allSelected, }) => {
    const [checked, setChecked] = (0, react_1.useState)(data.checked);
    const { locationName } = data;
    const handleChange = () => {
        if (locationName === 'SUMMARY') {
            selectAllLocation(!allSelected);
            return null;
        }
        const val = !checked;
        setChecked(val);
        setData({ locationName: locationName, checked: val });
    };
    return ((0, jsx_runtime_1.jsx)("td", { className: `actions ${locationName === 'SUMMARY' ? 'select-all-td' : ''}`, style: { justifyContent: 'center' }, children: locationName === 'SUMMARY' ? ((0, jsx_runtime_1.jsx)(components_1.ButtonLink, { onClick: handleChange, className: "select-all button-link", children: allSelected ? 'Deselect All' : 'Select All' })) : ((0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: checked, onChange: handleChange })) }));
};
ApplicationActionCell.propTypes = propTypes;
exports.default = (0, react_1.memo)(ApplicationActionCell);
